module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABoAAAAcCAYAAAB/E6/TAAAABHNCSVQICAgIfAhkiAAAAS5JREFUSEvtlrFNA0EQRd+vAJeAaAB3YJESQQVAB3YHJiMDVwCEZKYCHLgCciRKcAffGnSWLGu5293jAhATXTB7b/bP7MzI9jVwD4wYxpaSLmV7AzwAqwE4EfwTMA2QgTNJQ4CwHf9d/YO+0mj7AphImnXltVq6pkofgYWk6SAg22PgDXiVFM+i04pvVANpZM6vulpIEcj2OfACrIG7hFZjSYvvNMyWzvYHcNKRjFNJ7ymfbFBLpNFaroAbSfGdtF4g21mQohwdhlkCqQaVQqpAtqMLxNxqzUlCgfx31EQWs2Uk6bOzHew59CqG3wOyHfJEHo5Lok743u4mdlK6BhT7Q1/QvBXU8xY/3xlKAvrbVRcLZOwAyxJJMn13C+Qs9rqY/VFpR5mHS92eY7/YAqOPRJ43MbFTAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/case/case-nav-icon-active-06.png
// module id = AGP8
// module chunks = 1